import React, { useEffect, useState } from 'react';

import utils from 'utils/utils';
import { useProposalContext } from 'context/proposal';
import { ELEMENT_MENU } from 'constants/element-menu';
import ElementMenuGroup from './ElementMenuGroup';

import '../ElementsMenu.scss';

const isTouchOnlyDevice = utils.isTouchOnlyDevice();

const ElementsView = ({ showVariables, ...rest }) => {
  const { wixEditor, templateWixEditor, setScrollingTo } = useProposalContext();
  const isWix = !!(wixEditor || templateWixEditor);
  const [showElementsView, setShowElementsView] = useState(false);

  useEffect(() => {
    setShowElementsView(!showVariables);
  }, [showVariables]);

  if (!showElementsView) {
    return null;
  }

  return (
    <div className={`elements-menu ${isTouchOnlyDevice ? 'touch-device' : ''}`}>
      {ELEMENT_MENU.map((group) => (
        <ElementMenuGroup
          key={group.title}
          {...group}
          {...rest}
          setScrollingTo={setScrollingTo}
          isWix={isWix}
        />
      ))}
    </div>
  );
};

export default ElementsView;
